import script from "./InstrumentosView.vue?vue&type=script&lang=ts&setup=true"
export * from "./InstrumentosView.vue?vue&type=script&lang=ts&setup=true"

import "./InstrumentosView.vue?vue&type=style&index=0&id=489a59d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-489a59d8"]])

export default __exports__